<template lang="pug">

slide-drawer(
  v-model="showDrawerTemplatesTreeCopy"
  ref="slideDrawerEditor"
  @input="setShowDrawerTemplatesTree(false)"
)
  template(slot="title") {{ title }}
  template(slot="content")
    div.mt-5
      v-layout(row)
        v-flex(xs8)
          p.primary--text.title-tree 
            v-icon(color="primary" large) folder
            | &nbsp;&nbsp; {{templateToTreeTemplates.name}}
        v-flex(xs4)
          div.container-icons
            span.primary--text.mr-2.count-items(v-if="itemsCount(actionTypes.email) > 0") {{ itemsCount(actionTypes.email) }}
              v-icon(color="primary") email
            span.primary--text.mr-2.count-items(v-if="itemsCount(actionTypes.text) > 0") {{ itemsCount(actionTypes.text) }}
              v-icon(color="primary") tablet_android
            span.primary--text.mr-2.count-items(v-if="itemsCount(actionTypes.phone) > 0") {{ itemsCount(actionTypes.phone) }}
              v-icon(color="primary") phone
            span.primary--text.mr-2.count-items(v-if="itemsCount(actionTypes.direct) > 0") {{ itemsCount(this.actionTypes.direct) }}
              v-icon(color="primary") send
      v-container
        v-layout(row)
          ul.pa-0.ma-0(v-if="templates.length > 0")
            li(v-for="t of templates")
              v-layout.line(row wrap)
                v-flex(xs1)
                  v-icon.mt-3 {{ templateIconFromType(t.template_type) }}
                v-flex(xs8)
                  div.content-text
                    p.title-item.text-truncate {{ t.description }}
                    p.subtitle-item.text-truncate Subject: {{ t.subject }}
                v-flex(xs3)
                  div.container-icons
                    v-tooltip(bottom)
                      span Preview Template
                      v-btn.button-icon(
                        icon
                        slot="activator"
                        @click="handleTemplatePreview(t)"
                      )
                        v-icon remove_red_eye
                    v-tooltip(bottom)
                      span Edit Template
                      v-btn.button-icon(
                        icon
                        slot="activator"
                        @click="handleTemplateEdit(t)"
                      )
                        v-icon edit
                    v-tooltip(bottom)
                      span Delete Template
                      v-btn.button-icon(
                        icon slot="activator"
                        @click="handleRemoveResourceModal(t)"
                      )
                        v-icon delete
          h3.ml-4(v-else) No templates
  template(slot="actionsCustom")
    .slider-actions.justify-end    
      v-btn(
        flat
        color="primary"
        @click="setShowDrawerTemplatesTree(false);confirmDismissEditor = true"
      ) Close

</template>
<script>

import {
  mapActions,
  mapState,
  mapMutations,
} from 'vuex';
import SlideDrawer from '@/Core/components/SlideDrawer';
import { templateIconFromType } from '@/Campaigns/config/actions';

export default {
  components: {
    SlideDrawer,
  },
  data() {
    return {
      template: {},
      title: 'Folder Details',
      templates: [],
      actionTypes: {
        email: 'Email',
        phone: 'Phone',
        text: 'Text',
        direct: 'Direct',
        directPostCard: 'Direct Mail Postcard',
        directLetter: 'Direct Mail Letter',        
      }
    };
  },
  computed: {
     ...mapState('templates', [
      'showDrawerTemplatesTree',
      'showDrawerEdit',
      'showDeleteTemplateDialog',
      'templateToTreeTemplates'
    ]),
    showDrawerTemplatesTreeCopy: {
      get() {        
        return this.showDrawerTemplatesTree;
      },
      set(value) {
        this.setShowDrawerTemplatesTree(value);
      },
    },
  },
  watch: {
    templateToTreeTemplates: {
      handler(value) {
        if(!value)
          return;
        this.template = value;  
        this.fetchTemplates(value);      
      },
    },
  },

  methods: {
     ...mapActions('templates', [
      'getTemplatesInFolder',
    ]),
    ...mapMutations('templates', [
      'setTemplateToEdit',
      'setShowDrawerEdit',
      'setShowDrawerTemplatesTree',
      'setShowDeleteTemplateDialog',
      'setTemplateToRemove',
      'setEditing',
    ]),
     async fetchTemplates(folder) {
      this.templates = await this.getTemplatesInFolder({
        templateFolder: { id: folder.id},
      });
    },
    itemsCount(icon){
      let items = [];
      if(!this.templates.length) return 0;
      if(icon === this.actionTypes.direct) {
        items = this.templates.filter(p => p.template_type === this.actionTypes.directPostCard || p.template_type === this.actionTypes.directLetter);  
      } else{
        items = this.templates.filter(p => p.template_type === icon);
      }
      return items ? items.length : 0;
    },
    handleTemplateEdit(template) {
      this.setTemplateToEdit(template);
      this.setShowDrawerTemplatesTree(false);      
      this.setShowDrawerEdit(true);
      this.setEditing(true);
    },
    handleTemplatePreview(template) {
      this.setTemplateToEdit(template);
      this.setShowDrawerTemplatesTree(false);
      this.setShowDrawerEdit(true);
      this.setEditing(false);
    },
    handleRemoveResourceModal(template) {
      this.setTemplateToRemove(template);
      this.setShowDeleteTemplateDialog(true);
    },
    templateIconFromType,
  },
};
</script>
<style lang="scss" scoped>

$width-title: 85%;

.title-tree {
  font-size: 24px;
  margin-left: 22px;
}

.count-items {
  font-size: 18px;  
}

.title-item{
  margin-top: 10px;
  margin-bottom: 0px;
  font-weight: 600;
  font-size: 16px;
  width: $width-title;
}

.button-icon {
  margin-right: -14px;
  padding-right: 0px;
  color: var(--v-secondary-lighten3);
}

.container-icons{
  float: right;
  margin-right: 20px;
}

.content-text{
  width: 460px;

  .subtitle-item{
    width: $width-title;
  }
}

ul {
    list-style-type: none;

    li {
      list-style-type: none;
      border-left: 2px solid var(--v-secondary-lighten3);
      margin-left: 1em;
    

      .line {
          padding-left: 1em;
          position: relative;
          height: 55px;    
      }

      .line::before {
          content: '';
          position: absolute;
          top: 0;
          left: -2px;
          bottom: 50%;
          width: 0.75em;
          border: 2px solid var(--v-secondary-lighten3);
          border-top: 0 none transparent;
          border-right: 0 none transparent;
      }
    }
}

ul > li:last-child {
  border-left: 2px solid transparent;
}

</style>
